import { PageHeader } from "@components/kit/page-header";
import { LinkButton } from "@components/ui/interactive/link-button";
import { Container } from "@components/ui/structure/container";
import { Image } from "@components/ui/structure/image";
import { Spinner } from "@components/ui/structure/spinner";
import { useUser } from "@contexts/user";
import { useClasses } from "@styles";

export function HomeView() {
  const { ready, authenticated } = useUser();

  if (ready && !authenticated) {
    window.location.href = "/auth";
  }

  return (<>
    <Container className={useClasses('home-view')}>
      <Container
        className={useClasses("home-view-header")}
      >
        <Image
          src="/logo.png"
          alt="Delivr Logo"
          className={useClasses("home-view-logo")}
        />
      </Container>

      <Container className={useClasses("home-view-content")}>
        <PageHeader
          icon="TowerRegular"
          title="Delivr HQ"
        />

        <Container className={useClasses("home-view-links")}>
          {!ready && <Spinner />}
          {ready && authenticated && <>
            <LinkButton
              icon="DatabaseRegular"
              title="Data Access"
              url="/manage/data"
              urlText=""
              newTab={false}
            />

            <LinkButton
              icon="UserRegular"
              title="User Management"
              url="/manage/users"
              urlText=""
              newTab={false}
            />

            <LinkButton
              icon="BrightCrownRegular"
              title="Role Management"
              url="/manage/roles"
              urlText=""
              newTab={false}
            />

            <LinkButton
              icon="LockRegular"
              title="Permission Management"
              url="/manage/permissions"
              urlText=""
              newTab={false}
            />
          </>}

          {[...Array(6)].map(c => <Container children={null} />)}
        </Container>
      </Container>
    </Container>
  </>);
}

